import React, { useEffect } from "react";
import Helper from "../../common/helper";

import clsx from "clsx";
import { Add, ProductSelect, AdvantageCheckIcon } from "../../common/icons";
import { travellerBenefits } from "../../assets/benefits/benefits";
import ProductPricePoints from "../UI/product-price-points";

export const MembershipHeader = ({
  isSelected,
  itemName,
  className,
  languages,
}) => {
  const popularChoice = languages?.mostPopularChoice
    ? languages?.mostPopularChoice
    : "Most popular choice";
  return (
    <>
      <div
        className={clsx(
          `holder-title group border border-[#D1D5DB] rounded-md py-4 px-2 flex justify-center items-center gap-3 hover:bg-gradient-to-br hover:from-[#18A09F] hover:to-[#050033] ${className}`,
          {
            "holder-title-gradient": isSelected,
          }
        )}
      >
        <h5
          className={clsx(
            `text-sm tracking-tight text-[#050033] dark:text-[#FFFFFF] font-montserrat font-semibold uppercase text-center group-hover:text-[#FFF]`,
            {
              "text-[#FFFFFF]": isSelected,
            }
          )}
        >
          {itemName}
        </h5>
        {isSelected && <ProductSelect />}
      </div>
      <div className="item-info py-4 px-2">
        <p className="text-base tracking-tight text-[#050033] dark:text-[#FFFFFF] font-montserrat font-semibold text-center">
          {/* Best for regular traveller */}
          {itemName === "explorer" ? popularChoice : ""}
        </p>
      </div>
    </>
  );
};

export const AdvantagesList = ({ advantageText }) =>
  advantageText && (
    <div className="flex gap-4">
      <div>
        <AdvantageCheckIcon className="w-6 h-6" />
      </div>
      <p className="font-montserrat font-normal text-base text-left">
        {advantageText}
      </p>
    </div>
  );

export const returnAdvantageHeader = (itemName, languages, isMobile) => {
  const {
    TravellerAdvantageHeader,
    TravellerAdvantageMobileHeader,
    ExplorerAdvantageHeader,
    DiscoveryAdvantageHeader,
    ExplorerPlusAdvantageHeader,
  } = languages || {};
  const modifiedItemName = itemName.toLowerCase().trim();

  switch (modifiedItemName) {
    case "traveller":
      return (
        (isMobile
          ? TravellerAdvantageMobileHeader
          : TravellerAdvantageHeader) ||
        `Your ${isMobile ? "top " : ""}benefits:`
      );
    case "explorer":
      return ExplorerAdvantageHeader || languages.explorerAdvantageHeader;
    case "discovery":
      return DiscoveryAdvantageHeader || "All Explorer advantages, plus:";
    case "explorer plus":
      return ExplorerPlusAdvantageHeader || languages.explorerAdvantageHeader;
    case "business explorer":
      return ExplorerPlusAdvantageHeader || "All Explorer advantages, plus:";

    default:
      return TravellerAdvantageHeader || "Your benefits:";
  }
};

export const getPWPComponent = (languageMessage, defaultMessage, points) => {
  return (
    <div className="py-3">
      <span className="font-montserrat font-medium total-amount">{points}</span>
      <span className="font-montserrat font-medium uppercase">
        {" "}
        {languageMessage ? languageMessage : defaultMessage}
      </span>
    </div>
  );
};

export default function MultiCard({
  languages,
  products,
  selectMembership,
  couponObj,
  isUserLogged,
  locationDataCurrency,
  locationData,
  businessCategories,
  benefitsTranslations,
}) {
  const queryURLLocation = new URLSearchParams(window.location?.search);
  const autoSelectProduct = queryURLLocation.get("product");

  const focMultipleAvalailableMsg = () => {};

  useEffect(() => {
    if (autoSelectProduct) {
      let filterAutoSelectProduct;
      if (autoSelectProduct === "qantas") {
        filterAutoSelectProduct = products?.filter(
          (membership) => membership.qbrPoints
        );
      } else {
        filterAutoSelectProduct = products?.filter((membership) =>
          membership.item_group_name?.toLowerCase().includes(autoSelectProduct)
        );
      }
      const selectProduct = filterAutoSelectProduct[0];

      if (selectProduct) {
        selectMembership(selectProduct);
      }
    }
  }, []);

  return (
    <React.Fragment>
      {products.map((item, index) => {
        const itemGroupName = item.item_group_description.toLowerCase();
        const itemGroupId = item.item_group_id;
        const itemName = itemGroupName
          .replace(/ACCOR PLUS | MEMBERSHIP/gi, "")
          .trim();
        let totalAmt =
          parseFloat(item.purchase_price) + parseFloat(item.tax_amt);
        let currency = item.currency_text
          ? item.currency_text
          : locationDataCurrency;
        const component_items =
          item.component_items || item.item_group_components;
        const foc = Helper.focLength(component_items);
        const getCoupon = Helper.checkCoupon(item, couponObj);
        const travellerMembership =
          itemGroupName && itemGroupName.includes("traveller");
        const DiscoveryMembership =
          itemGroupName && itemGroupName.includes("discovery") ? true : false;
        const ExplorerMembership = itemGroupId === "4291";
        const ExplorerPlusMembership = itemGroupId === "4293";
        const getVoucherDetails = Helper.voucherBenefitsChecker(
          locationData.country
        );

        console.log('getVoucherDetails', getVoucherDetails)
        const isAMEX = Helper.isAMEX();
        const isSCB = Helper.isSCB();
        const isBasePrice = item.priceLevel?.includes("BASE PRICE");
        // const PWPs                = Helper.checkPwp(item, isUserLogged, locationData, businessCategories); // This is now deprecated.
        const PWP = Helper.newpwpCheck(
          item,
          isUserLogged,
          locationData,
          businessCategories
        );
        let isQbr = item.isQbr ? true : false;

        let TravellerBenefits = benefitsTranslations.benefits[0].traveller;
        let ExplorerBenefits = benefitsTranslations.benefits[1].explorer;
        let ExplorerPlusBenefits =
          benefitsTranslations.benefits[2]["explorer plus"];
        let DiscoveryBenefits = benefitsTranslations.benefits[3].discovery;

        console.log(foc + languages.productFocAvailableSingleMessage, "foc");
        return (
          <div
            className={clsx(
              "card max-w-[266.67px] bg-white tablet:mx-15 desktop:hover:scale-105 duration-500",
              {
                selected: item.isSelected ? true : false,
              }
            )}
            key={index}
            onClick={() => selectMembership(item)}
          >
            <div className="card-wrapper group h-full rounded border-2 hover:border-[#18A09F]">
              <div className="content-holder flex flex-col h-full">
                <div className="flex flex-col h-full p-5">
                  {/* Item Group Title Start */}
                  <MembershipHeader
                    isSelected={item.isSelected}
                    itemName={itemName}
                    languages={languages}
                  />
                  {/* Item Group Title End */}
                  <div className="content-text py-3">
                    {/* Item Group Price | Currency - Start */}

                    <ProductPricePoints
                      currency={currency}
                      totalAmt={totalAmt}
                      isUserLogged={isUserLogged}
                      isQbr={isQbr}
                      languages={languages}
                      PWP={PWP}
                      getCoupon={getCoupon}
                      item={item}
                      locationData={locationData}
                      getPWPComponent={getPWPComponent}
                    />
                    {/* Item Group Price | Currency - End */}

                    {/* Benefits Start */}
                    <div>
                      <h5 className="font-semibold mt-4">
                        {returnAdvantageHeader(itemName, languages)}
                      </h5>
                      <ul className="membership-inclusions mb-5">
                        {/* benefitsTranslations */}
                        {travellerMembership &&
                          TravellerBenefits.map((advantage, id) => (
                            // console.log('advantage', advantage)
                            <li
                              key={id}
                              className={clsx({
                                "mt-4": id === 0,
                              })}
                            >
                              <AdvantagesList
                                advantageText={
                                  advantage[benefitsTranslations.region]
                                }
                              />
                            </li>
                          ))}

                        {DiscoveryMembership &&
                          DiscoveryBenefits.map((advantage, id) => (
                            <li
                              key={id}
                              className={clsx({
                                "mt-4": id === 0,
                              })}
                            >
                              <AdvantagesList
                                advantageText={
                                  advantage[benefitsTranslations.region]
                                }
                              />
                            </li>
                          ))}
                        {/* {foc !== 0 && ExplorerMembership && (
                          <li className='inclusion-list flex items-center'>
                            <div className='list-icon-holder'>
                              <AdvantageCheckIcon />
                            </div>
                            <span className='list-desc text-base text-left'>
                              {foc > 1 ?
                                foc + languages.productFocAvailableMultipleMessage ? languages.productFocAvailableMultipleMessage : " Stay Plus complimentary nights"
                                :
                                foc + languages.productFocAvailableSingleMessage ? languages.productFocAvailableSingleMessage : " Complimentary night stay at participating hotels "
                              }
                            </span>
                          </li>
                        )} */}
                        {foc !== 0 &&
                          !isQbr &&
                          ExplorerMembership &&
                          ExplorerBenefits?.map(
                            (
                              advantage,
                              id // non-qbr
                            ) => (
                              <li
                                key={id}
                                className={clsx({
                                  "mt-4": id === 0,
                                })}
                              >
                                <AdvantagesList
                                  advantageText={
                                    advantage[benefitsTranslations.region]
                                  }
                                />
                              </li>
                            )
                          )}
                        {foc !== 0 &&
                          !isQbr &&
                          ExplorerPlusMembership && !isSCB &&
                          ExplorerPlusBenefits.map(
                            (
                              advantage,
                              id // non-qbr
                            ) => (
                              <li
                                key={id}
                                className={clsx({
                                  "mt-4": id === 0,
                                })}
                              >
                                <AdvantagesList
                                  advantageText={
                                    advantage[benefitsTranslations.region]
                                  }
                                />
                              </li>
                            )
                          )}
                        {foc !== 0 && ExplorerMembership && isQbr && (
                          <li className="inclusion-list flex items-center">
                            {foc > 1 ? (
                              <AdvantagesList
                                advantageText={
                                  languages?.productFocAvailableMultipleMessage ||
                                  "Stay Plus complimentary nights"
                                }
                              />
                            ) : (
                              <AdvantagesList
                                advantageText={
                                  languages?.productFocAvailableSingleMessage ||
                                  "Complimentary night stay at participating hotels"
                                }
                              />
                            )}
                          </li>
                        )}
                        {ExplorerMembership &&
                        isBasePrice &&
                        !ExplorerPlusMembership &&
                        !isQbr &&
                        languages.productBonusRewardPoints ? (
                          <li className="inclusion-list flex items-center gap-4">
                            <div className="list-icon-holder">
                              <AdvantageCheckIcon />
                            </div>
                            <span className="text-base text-left">
                              {languages.productBonusRewardPoints
                                ? languages.productBonusRewardPoints
                                : "Bonus 2,000 Reward Points (For a limited time)"}
                            </span>
                          </li>
                        ) : (
                          <></>
                        )}
                        {DiscoveryMembership &&
                          getVoucherDetails[1].discovery &&
                          !isAMEX && (
                            <li className="inclusion-list flex items-center gap-4">
                              <div className="list-icon-holder">
                                <AdvantageCheckIcon />
                              </div>
                              <span className="text-base text-left">
                                {languages.productVoucherBenefitsDiscovery
                                  ? languages.productVoucherBenefitsDiscovery
                                  : " Exclusive dining and accommodation discount vouchers"}
                              </span>
                            </li>
                          )}
                        {ExplorerMembership &&
                          getVoucherDetails[0].explorer &&
                          !isAMEX && (
                            <li className="inclusion-list flex items-center">
                              <AdvantagesList
                                advantageText={
                                  languages?.productVoucherBenefitsExplorer ||
                                  " Exclusive dining and accommodation discount vouchers"
                                }
                              />
                            </li>
                          )}
                        {ExplorerPlusMembership &&
                          getVoucherDetails[2]?.explorer_plus &&
                          !isAMEX && (
                            <li className="inclusion-list flex items-center">
                              <AdvantagesList
                                advantageText={
                                  languages?.productVoucherBenefitsExplorer ||
                                  " Exclusive dining and accommodation discount vouchers"
                                }
                              />
                            </li>
                          )}
                        {/*Helper.isQbr(locationData) && (
                          <li className='inclusion-list flex items-center'>
                            <div className='list-icon-holder'>
                              <AdvantageCheckIcon />
                            </div>
                            <span className='list-desc text-lg'>Gold membership status in ALL – Accor Live Limitless</span>
                          </li>
                          )*/}
                      </ul>
                    </div>
                    {/* Benefits End */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
}
